/* eslint-disable react/prop-types */
import React from 'react';

export default function SFButton({ variant, text, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`btn w-full rounded-full py-3 my-5 ${
        variant === 'success'
          ? 'bg-noti-200 hover:bg-portal-100 text-white hover:text-portal-900 '
          : 'bg-white hover:bg-portal-100 text-portal-300 border border-portal-300'
      }`}>
      {text.replace(/\b\w/g, (l) => l.toUpperCase())}
    </button>
  );
}
